import event from 'events'
export default event.EventEmitter
